// extracted by mini-css-extract-plugin
export default {"container":"HE-z","modal":"IE-z","dimensions":"JE-z","brandName":"KE-z","productName":"LE-z","labelValue":"ME-z","recipientEmail":"NE-z","recommendedFit":"OE-z","hiddenField":"PE-z"};